<template>
    <div ref="sidebar" id="sidebar">
      <div class="sidebar_content sidebar_head">
        <feather-icon
          @click="hiddenModal()"
          icon="XIcon"
          svgClasses="h-6 w-6 head_icon"
        />
        <h1 class="head_title">Publicación {{ dataView.meli_id }}</h1>
      </div>
      <div class="sidebar_content sidebar_body">
        <div class="body_title-wrapper">
          <p class="title_text">Detalle</p>
        </div>
        <div class="body_center-wrapper">
          <img
            v-if="dataView.thumbnail"
            width="60px"
            height="60px"
            :src="dataView.thumbnail"
            :alt="dataView.title"
          />
          <p class="center_text">{{ dataView.title }}</p>
        </div>
        <hr class="divider" />
        <div class="body_footer">
          <div class="footer__text-wrapper">
            <p class="footer_text-left">Valor</p>
            <p class="footer_text-rigth">${{ dataView.price }}</p>
          </div>
        </div>
      </div>
      <div class="sidebar_content sidebar_body">
        <div class="body_title-wrapper">
          <p class="title_text">Dimensiones</p>
        </div>
        <div class="body_footer">
          <div class="footer__text-wrapper footer__text--no-bold">
            <!-- <p class="footer_text-left">Paquete {{ dataView.id }}</p> -->
            <p class="footer_text-rigth" v-if="dataView.shipping_dimensions == null">Sin definir</p>
            <p class="footer_text-rigth" v-if="dataView.shipping_dimensions != null">{{ dataView.shipping_dimensions }}</p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "PublicationsView",
    props: {
      dataView: Object,
    },
    data() {
      return {
        sidebar: null,
      };
    },
    mounted() {
      document.getElementById("sidebar").classList.add("show");
      console.log(this.dataView);
    },
    methods: {
      hiddenModal() {
        document.getElementById("sidebar").classList.remove("show");
        this.$emit("dataView", this.dataView);
      },
    },
  };
  </script>